module.exports = {
	"login": {
		"login": "Entrar",
		"entering": "Entrando...",
		"no_register": "Não possui cadastro? ",
		"register_now": "Cadastre-se agora!",
		"user": "Usuário",
		"subdomain": "Domínio da loja",
		"you_domain": "Domínio da sua loja",
		"mail": "E-mail",
		"mail_adm": "E-mail do administrador",
		"password": "Senha",
		"forgot_password": "Esqueci minha senha",
		"put_your_email": "Digite seu e-mail e enviaremos um link para redefinir sua senha.",
		"send_link_to_my_email": "Enviar link para meu e-mail",
		"sending_link_to_my_email": "Enviando...",
		"register_new_password": "Cadastre uma nova senha",
		"type_new_password_for_your_account": "Digite uma nova senha para sua conta",
		"signin": "Login",
		"forgot_your_password": "Esqueceu sua senha?",
		"new_password": "Nova senha",
		"confirm_password": "Confirmação de senha",
		"alert": {
			"login_error": "Não foi possível efetuar login. Email e/ou senha inválidos.",
			"check_passwords": "Verifique se as senhas estão digitadas corretamente.",
			"password_created_successfully": "Senha nova cadastrada com sucesso!",
			"invalid_domain": "Domínio inválido"
		},
		"attributes": {
			"password": "Senha",
			"confirm_password": "Confirmar senha",
			"go_to_link": "Ir para tela de",
			"or": "ou"
		},
		"placeholder": {
			"new_password": "Nova senha",
			"confirm_password": "Confirmar senha"
		},
		"field": {
			"required": "Campo obrigatório"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./~/yaml-loader!./src/lang/login/pt-BR.yml
// module id = 585
// module chunks = 1